module.exports = __webpack_public_path__ + "img/lv1.239d4a89.png";